import { render, staticRenderFns } from "./Folders2.vue?vue&type=template&id=6e403604&scoped=true"
import script from "./Folders2.vue?vue&type=script&lang=js"
export * from "./Folders2.vue?vue&type=script&lang=js"
import style0 from "./Folders2.vue?vue&type=style&index=0&id=6e403604&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e403604",
  null
  
)

export default component.exports